import React, { Component } from 'react'
import { buildTitle } from '../../components/UserProfile'
import CollapsibleSection from '../../controls/CollapsibleSection'
import { Row, Col } from 'react-flexbox-grid'
import RBButton from '../../controls/RBButton'
import PasswordField from '../../controls/PasswordField'
import InputField from '../../controls/InputField'
import { localize } from '../../util/Localizer'
import IconButton from '@material-ui/core/IconButton'
import Icon from '@material-ui/core/Icon'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { updateUser } from '../../redux/actions/userProfileActions'
import { push } from 'connected-react-router'
import Tooltip from '../../controls/Tooltip'
import RBSelectField from '../../controls/RBSelectField'
import { Colors } from '../../theme'

class SecurityAnswer extends Component {
  constructor (props) {
    super(props)
    this.checkEnter = this.checkEnter.bind(this)
    this.enterSave = this.enterSave.bind(this)
    this.redirect = this.redirect.bind(this)
    this.saveInfo = this.saveInfo.bind(this)
    this.disableButton = this.disableButton.bind(this)
    this.reset = this.reset.bind(this)

    const { securityQuestion = '', securityQuestions = [] } = props
    if (securityQuestions.indexOf(securityQuestion) === -1) {
      securityQuestions.push(securityQuestion)
    }

    this.state = {
      certificateNumber: props.certificateNumber,
      email: props.email,
      username: props.username,
      securityQuestion: securityQuestion,
      securityAnswer: props.securityAnswer,
      securityQuestions: securityQuestions,
      password: ''
    }

    this.baseState = this.state
  }

  static getDerivedStateFromProps (props, state) {
    // since the email is driven from a prop, we need to make sure our state for email is update to date
    // incase the user changes the email which is in a different section
    if (props.email !== state.email) {
      return { email: props.email }
    }
    return null
  }

  componentDidMount () {
    this.reset()
  }

  redirect () {
    window.location.reload()
  }

  reset () {
    const base = this.baseState
    this.setState({ ...base })
  }

  saveInfo () {
    const profileUpdate = {
      certificateNumber: this.state.certificateNumber,
      email: this.state.email,
      username: this.state.username,
      currentpassword: this.state.password,
      securityQuestion: this.state.securityQuestion,
      securityAnswer: this.state.securityAnswer
    }
    this.props.updateUser(profileUpdate, (data) => {
      this.props.saveComplete(data)
    }, (data) => {
      this.props.errorOnSave(data)
    })
    this.setState({ ...profileUpdate })
  }

  checkEnter (event) {
    const code = (event.keyCode ? event.keyCode : event.which)
    if (code === 13) {
      this.setState({ enterSave: true }, this.enterSave)
    }
  }

  enterSave () {
    if (this.state.enterSave) {
      this.setState({ enterSave: false })
      if (!this.disableButton()) {
        this.saveInfo()
      }
    }
  }

  disableButton () {
    const s = this.state

    return !(s.password && s.securityAnswer)
  }
  render () {
    const values = this.state
    // const questions = (this.state.securityQuestions || []).map((sq) => {
    //   return { id: sq, text: sq }
    // })
    return (
      <div>
        <CollapsibleSection
          id='security'
          showMuiBorder={false}
          isProfile={this.props.isProfile}
          heading={buildTitle('pages.userProfile.title.question', 'pages.userProfile.subtitle.question')}
          expanded={this.props.expanded}
          onExpanded={(key, expanded) => this.props.onExpanded(expanded)}>
          <Row>
            <Col xs={11} md={6}>
              <br />
              <PasswordField
                id='securityPassword'
                type='password'
                fullWidth
                floatingLabelText={localize('pages.userProfile.currentPassword')}
                value={values.password}
                onChange={(e, password) => this.setState({ password })}
                onKeyPress={this.checkEnter}
                errorText={values.currentPassError}
              />
              <div className='tooltipInput'>
                <RBSelectField
                  id='securityQuestion'
                  label={localize('pages.userProfile.securityQuestion')}
                  fullWidth
                  sendValues={(securityQuestion) => this.setState(securityQuestion)}
                  selected={this.state.securityQuestion}
                  maxHeight={300}
                  data={this.state.securityQuestions}
                />
                <Tooltip title={localize('common.tooltip.securityQuestion')} placement="right-end">
                  <IconButton className='tooltip'>
                    <Icon style={{ color: Colors.Palette.primaryTextColor, fontSize: 25 }}>info</Icon>
                  </IconButton>
                </Tooltip>
              </div>

              <InputField
                fullWidth
                id='securityAnswer'
                type='text'
                floatingLabelText={localize('pages.userProfile.answer')}
                onChange={(e, securityAnswer) => this.setState({ securityAnswer })}
                onKeyPress={this.checkEnter}
                value={values.securityAnswer}
              />
            </Col>
          </Row>
          <div className='buttonContainer fltRight'>
            <RBButton
              variant='outlined'
              id='cancelBtn'
              label={localize('common.cancel')}
              onClick={this.redirect} />
            <RBButton
              variant='contained'
              id='saveBtn'
              label={localize('common.saveUpdates')}
              primary
              onClick={this.saveInfo}
              disabled={this.disableButton()}
              loading={this.props.pageLoading}
            />
          </div>
        </CollapsibleSection>
        <hr />
      </div>
    )
  }
}
function mapStateToProps (state, ownProps) {
  return Object.assign({}, ownProps, {
    pageLoading: state.UserProfileReducers.isFetching
  })
}
const ConnectedSecurityAnswer = connect(mapStateToProps, { updateUser, push })(injectIntl(SecurityAnswer))
export default ConnectedSecurityAnswer



// WEBPACK FOOTER //
// ./src/widgets/userProfile/SecurityAnswer.js